import { z } from '../../zod';
import { ObjectIdStringValidationSchema } from '../../shared/ObjectId';
import {
  ThemeOverridesInputValidationSchema,
  ThemeOverridesToolInputValidationSchema,
} from '../themeOverrides';

export const ThemeNameValidationSchema = z.string().trim().min(1).max(100).meta({
  description: 'Theme name, unique within your account.',
});

const baseThemeId = ObjectIdStringValidationSchema.optional().meta({
  description:
    "A theme to start from: one of your themes or a built-in one. The new theme copies all of its settings, including order bump styling, which only the dashboard can change, and `variables` is applied on top. A copy of a built-in theme does not pick up your store's brand color automatically; set `tokens.colorPrimary` if you want it.",
});

export const THEME_VARIABLES_INPUT_DESCRIPTION =
  "Design and labels to set, in the same shape as a page's `themeOverrides`. Keys you leave out keep their value, and `null` resets a property, or everything under a key.";

// Field-level meta on variables would inline the whole ThemeOverridesInput schema instead of a $ref.
export const CreateThemeBodyValidationSchema = z.object({
  name: ThemeNameValidationSchema,
  baseThemeId,
  variables: ThemeOverridesInputValidationSchema.nullish(),
});

export const CreateThemeToolInputValidationSchema = z.object({
  name: ThemeNameValidationSchema,
  baseThemeId,
  variables: ThemeOverridesToolInputValidationSchema.meta({
    description: `${THEME_VARIABLES_INPUT_DESCRIPTION} Call \`list_theme_properties\` for the supported properties.`,
  }),
});
